<template>
  <base-dialog-component
    :showInfoIcon="false"
    :showClose="true"
    :open="open"
    :title="$t(title)"
    :body="$t(body)"
    @closeDialog="closeDialog"
    height="400px"
    width="33vw"
    maxWidth="600px"
    right="50px"
    bottom="50px"
    :overlay="false"
    :center="false"
  ></base-dialog-component>
</template>
<script>
import baseComponent from "./baseComponent.vue";

export default {
  name: "dialogCTAComponent",
  components: {
    baseDialogComponent: baseComponent,
  },
  data() {
    return {
      open: false,
      resolveDialog: null,
      title: null,
      body: null,
    };
  },
  beforeMount() {
    this.$root.$on("dialogCTA", this.dialogCTA);
  },
  beforeDestroy() {
    this.$root.$off("dialogCTA", this.dialogCTA);
  },
  methods: {
    closeDialog() {
      this.resolveDialog(false);
      this.open = false;
    },
    dialogCTA({ resolve, title, body }) {
      this.title = title;
      this.body = body;
      this.resolveDialog = resolve;
      this.open = true;
    },
  },
};
</script>
